import type { ReactNode } from 'react';

type P = {
  children: ReactNode;
};

const EventInviteesListContentWrapper = ({ children }: P) => (
  <div className="event-invitees-list-content-wrapper">{children}</div>
);

export default EventInviteesListContentWrapper;
